import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, y = 28, className = "" }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </motion.div>
    );
}

export function Logo({ compact = false }) {
    return (
        <span className="flex items-center gap-2.5" data-testid="brand-logo">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-slate-900">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M2 11.5L6 7.5L8.5 10L14 4" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M10.5 4H14V7.5" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </span>
            <span className="leading-none">
                <span className="font-display text-[17px] font-extrabold tracking-tight text-slate-900">ITF</span>
                {!compact && (
                    <span className="mt-0.5 block font-mono text-[9px] font-semibold uppercase tracking-[0.22em] text-slate-500">
                        Institutional Trend Flow
                    </span>
                )}
            </span>
        </span>
    );
}
